import {configurationReducer} from '../features/configuration/configuration-slice';

export const configuration = configurationReducer;
